// Hint: you should probably be using listRelated or listChildren,
// this is to get a raw location doc that does not safely filter out by user funders
// nor give you the current service nor funder ids (and maybe other things).
// If you have to use this, always do so followed with /tools/location-docs/.getLocation(doc, date)
exports.listAllRaw = state => {
  return state.dal.location.listAll(state)
}
